import isEmpty from 'lodash/isEmpty';
import { ILookUpUserApiResponseProps } from '../api/lookup';
import { SIGN_IN_METHOD_PASSWORD } from '../constants';
import {
    GA_CONTINUE_CREATE_ACCOUNT_CLICKED,
    GA_CONTINUE_CREATE_ACCOUNT_EXISTS,
    GA_CONTINUE_CREATE_ACCOUNT_NEW,
    GA_EVENTBRITE,
} from '../constants/analytics';
import { IAllContextsProps } from '../constants/interfaces';
import { SIGNUP_EMAIL_EXISTS } from '../constants/messages';
import { trackGeneralAuthAction } from '../tracking/general';
import { handleUserIsSocial, handleUserIsSoftAccount } from './lookupHandlers';

export const handleSignupUserResponse = ({
    response,
    email,
    contexts,
}: {
    response: ILookUpUserApiResponseProps;
    email: string;
    contexts: IAllContextsProps;
}) => {
    const {
        notificationsContext,
        configContext,
        userContext,
        frontendContext,
    } = contexts;
    const analytics = configContext?.analytics;
    const { userId, signInMethods } = response;

    trackGeneralAuthAction({
        analytics: configContext?.analytics,
        action: GA_CONTINUE_CREATE_ACCOUNT_CLICKED,
        label: GA_EVENTBRITE,
    });

    notificationsContext?.methods.setGeneralNotification({});
    userContext?.methods.lookup.setSocialConnected([]);

    if (userId) {
        userContext?.methods.lookup.setExistentAccount(email);

        if (isEmpty(signInMethods)) {
            handleUserIsSoftAccount({ contexts });
        } else if (signInMethods.includes(SIGN_IN_METHOD_PASSWORD)) {
            trackGeneralAuthAction({
                analytics,
                action: GA_CONTINUE_CREATE_ACCOUNT_EXISTS,
                label: GA_EVENTBRITE,
            });

            const notificationConfig = configContext?.signupMethods?.error?.HAS_PASSWORD?.getNotification?.(
                response,
            );

            notificationsContext?.methods.setGeneralNotification({
                message: SIGNUP_EMAIL_EXISTS,
                cta: {
                    action: notificationConfig?.ctaAction,
                    message: notificationConfig?.ctaMessage,
                },
            });
        } else {
            handleUserIsSocial({
                signInMethods,
                contexts,
            });
        }
    } else {
        trackGeneralAuthAction({
            analytics,
            action: GA_CONTINUE_CREATE_ACCOUNT_NEW,
            label: GA_EVENTBRITE,
        });

        frontendContext?.methods.setSignupSecondStep(true);
    }
};
